import { apiClient } from "../../../base/ApiClient";


export const getIssueTypes = async (page = 1, pagination = true) => {
  const res = await apiClient.get("/careplan/api/issue-types/", {
    params: {
      page,
      pagination: pagination,
    },
  });
  return res.data;
};

export const createIssueType = async (data) => {
  const res = await apiClient.post("/careplan/api/issue-types/", data);
  return res.data;
};

export const updateIssueType = async ({ id, name }) => {
  const res = await apiClient.patch(`/careplan/api/issue-types/${id}/`, { name });
  return res.data;
};

export const deleteIssueType = async (id) => {
  const res = await apiClient.delete(`/careplan/api/issue-types/${id}/`);
  return res.data;
};